import axios from "../../privateApi";

interface ResetWebAppStateArgs {
  overridePlanned: boolean;
}
export const resetWebAppState = ({ overridePlanned }: ResetWebAppStateArgs) => {
  return axios.post(`/user-evolutions/reset`, {
    overridePlanned,
  });
};
